import { complaintmodel } from "../../models/complaints/complaint-model";
import * as XLSX from 'xlsx';

export const complaintsExport = (complaintList: complaintmodel[], complaintType: 'product' | 'service') => {
  const orderData = complaintWiseData(complaintList, complaintType);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(orderData);

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, 'ComplaintListExport.xlsx');
};

const formatDateSafely = (date: any) => {
  if (!date) return ""; 
  const parsed = new Date(date);
  return isNaN(parsed.getTime())
    ? "" 
    : parsed.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
};

const complaintWiseData = (complaintList: complaintmodel[], complaintType: 'product' | 'service') => {
  const flatData: any[] = [];

  complaintList?.forEach((complaint) => {
    const commonFields = {
      'Complaint Date': formatDateSafely(complaint.createdDate), 
      'Description': complaint.description || "",
      'Remarks': complaint.remarks || "",
      'Severity': complaint.severity || "",
      'Customer Support Action': complaint.customerSupportAction || "",
      'Customer Name': complaint.customerName || "",
      'Primary Contact': complaint.mobile || "",
      'Created By': complaint.createdByName || "System",
      'Modify by Name': complaint.modifiedByName || "System",
      'Modify date': complaint.modifiedDate ,
    };

    if (complaintType === 'product') {
      flatData.push({
        ...commonFields,
        'Invoice No': complaint.invoiceId || "",
        'Product Name': complaint.productName || "",
      });
    } else {
      flatData.push({ ...commonFields });
    }
  });

  return flatData;
};
